const collectNoWill = async (token: string) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/collect-no-will`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	return response.json();
};

export default collectNoWill;
